import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverDeductionHistoryReport extends Layout {
    checkboxExcludeTaxDeductions: Checkbox;
    checkboxSubtotalByTractor: Checkbox;
    excludabletextboxGLAccount: ExcludableTextbox;
    excludabletextboxPayAdjustmentCodes: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceDriverDeductionHist: DataSource;
    switchReportType: Switch;
    textboxCheckDateRange: Textbox;
    textboxGroupBy: Textbox;
    textboxPayeeType: Textbox;
}
